// extracted by mini-css-extract-plugin
export default {"link":"QM-z","disabled":"RM-z"};